import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export default function PageContent({ internalId, fallbackTitle, fallbackContent }) {
    const [page, setPage] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        axios
            .get(`${API_BASE_URL}/api/pages/${internalId}`, { skipAuth: true })
            .then((response) => {
                if (!cancelled) {
                    setPage(response.data || null);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setPage(null);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [internalId]);

    const title = page?.title || fallbackTitle;
    const content = page?.content || fallbackContent;

    return (
        <div className="cms-page-root">
            <div className="cms-page-inner">
                <article className="cms-page-panel">
                    <h1 className="cms-page-title">{title}</h1>
                    {loading && !page
                        ? <p className="cms-page-loading">Загрузка…</p>
                        : <div className="rich-content cms-page-content" dangerouslySetInnerHTML={{ __html: content }} />
                    }
                </article>
            </div>
        </div>
    );
}
